const PROPERTY_OPTIONS = [
  { value: "land", label: "Land", icon: "🌿" },
  { value: "house", label: "House", icon: "🏠" },
  { value: "shop", label: "Shop", icon: "🏪" }
];

export default function PropertyTypeSelector({ description, onClose, onSelect, title }) {
  return (
    <>
      <div className="fy-modal-head">
        <h3>{title}</h3>
      </div>

      <p className="fy-subcopy">{description}</p>

      <div className="fy-type-grid">
        {PROPERTY_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className="fy-type-item"
            onClick={() => onSelect(option.value)}
          >
            {option.icon}
            <span>{option.label}</span>
          </button>
        ))}
      </div>
    </>
  );
}
